import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { ToolsService } from '../../services/tools.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {
  query: string = '';
  categoria: string;
  lastItem: any;
  searchTerm$ = new Subject<string>();
  menuFilter: any[] = [];
  @Input() menu: any[] = [];
  expand: any;
  media: any;
  constructor(private router: Router, private tools: ToolsService) {

    this.tools.$collapseStatus.subscribe((status: any) => {
      this.expand = status;
    })

    // observable input search events
    this.searchTerm$
      .pipe(
        debounceTime(700),
        distinctUntilChanged(),
        switchMap(query => this.tools.search(this.menu, query, 'recursos')),
      ).subscribe((response: any) => {
        this.menuFilter = response;
      })
  }

  ngAfterViewChecked() {
  }


  redirect(item: any) {
    this.router.navigate([item.url]);
    this.tools.updateMenu(item);
    if (!this.lastItem) {
      this.lastItem = item;
    } else {
      this.lastItem.active = false;
      this.lastItem = item;
    }
    item.active = true;
    if (document.body.clientWidth < 960) {
      this.tools.collapse();
      this.lastItem.active = false;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (typeof changes.menu !== 'undefined') {
      this.menuFilter = this.menu;
    }
  }


}




